export const checkReduceMotion = (): boolean => {
	if (typeof window !== 'object') {
		return false;
	}
	return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};
